<script>
import Buttons from '@components/buttons'
import CategoryForm from '@components/announcement/category/category-form'


export default {
  name: 'AnnouncementCreate',
  components: { CategoryForm, Buttons },
  props: {
    call: {
      type: Function,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      form:{},
      buttons: [
        {
          id: 'create-category',
          name: 'Create',
          type: 'submit',
          class: 'btn-primary px-5',
          disabled: true,
          method: (form) => {
            this.$store.dispatch('category/createCategory', form)
            this.$props.call('Home')
          },
        },
        {
          id: 'cancel-category',
          name: 'Cancel',
          type: 'button',
          class: 'btn-secondary ml-1',
          method: () => {
            this.$props.call('Home')
          },
        },
      ],
    }
  }, 

  methods: {
    canSubmit(isInvalid) {
      this.buttons.forEach((b) => {
        if (b.hasOwnProperty('disabled')) b.disabled = isInvalid
      })
    },
  },


}
</script>
<template>
  <div class="col-lg-10 col-xl-10 col-xxl-8 create-campaign card">
    <CategoryForm
      :form="form"
      :buttons="buttons"
      :can-submit="canSubmit"
    >
      <div slot="submit" class="campaign-submit text-right py-3">
        <Buttons :buttons="buttons" :form="form" />
      </div>
    </CategoryForm>
  </div>
</template>
